import React, { Suspense, lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';

// El uso de `lazy` permite cargar componentes solo cuando se necesitan,
// mejorando la experiencia del usuario y reduciendo las cargas iniciales.
// En lugar de importar los componentes directamente, se utiliza una función de lazy loading,
// que devuelve un componente cuando sea necesario.
// Esto permite a React cargar solo lo que es necesario en cada momento,
// mejorando la velocidad y eficiencia del aplicativo.
const LoginForm = lazy(() => import('./components/LoginForm'));
const DocumentUpload = lazy(() => import('./components/DocumentUpload'));
const Welcome = lazy(() => import('./components/Welcome'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const ContractList = lazy(() => import('./components/GrillaContrato/UsuarioInicial/Contract'));
const Tramite = lazy(() => import('./components/Tramite'));
const TramiteSummary = lazy(() => import('./components/tramite/TramiteResumen'));

// Loading component
const Loading = () => <div>Loading...</div>;

function AppRoutes() {
  return (
    <AuthProvider>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/welcome" element={<Welcome/>} />
          <Route path="/upload" element={<ProtectedRoute element={DocumentUpload} />} />
          <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
          <Route path="/contractlist" element={<ProtectedRoute element={ContractList} />} />
          <Route path="/tramite" element={<ProtectedRoute element={Tramite} />} />
          <Route path="/tramite-summary" element={<ProtectedRoute element={TramiteSummary} />} />
          {/* Catch-all route to handle undefined routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default AppRoutes;